import * as type from "../types";

export function getSessionCollateralRequest(value) {
    return {
      type: type.GET_SESSION_COLLATERAL_REQUESTED,
      payload: value,
    };
  }

  export function getSessionCollateralSucceeded(value) {
    return {
      type: type.GET_SESSION_COLLATERAL_SUCCEEDED,
      payload: value,
    };
  }

  export function getSessionCollateralFailed(value) {
    return {
      type: type.GET_SESSION_COLLATERAL_FAILED,
      payload: value,
    };
  }

 export function setSessionCollateralFilterDate (date){
  return {
     type: type.SET_SESSION_COLLATERAL_FILTER_DATE,
     payload: date
  }
 }

 export function getSessionCurrentBlockedAmountDetailsRequest(value){
  return {
    type: type.GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_REQUESTED,
    payload: value
  }
 }

  export function getSessionCurrentBlockedAmountDetailsSucceeded(value){
  return {
    type: type.GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_SUCCEEDED,
    payload: value
  }
 }

  export function getSessionCurrentBlockedAmountDetailsFailed(value){
  return {
    type: type.GET_SESSION_CURRENT_BLOCKED_AMOUNT_DETAILS_FAILED,
    payload: value
  }
 }

 export function getAllSessionsRequested() {
  return {
    type: type.GET_ALL_SESSIONS_REQUESTED,
  };
}
export function getAllSessionsSucceeded(data) {
  return {
    type: type.GET_ALL_SESSIONS_SUCCEEDED,
    payload: data,
  };
}
export function getAllSessionsFailed() {
  return {
    type: type.GET_ALL_SESSIONS_FAILED,
  };
}